import { render, staticRenderFns } from "./eduContinue.vue?vue&type=template&id=6533a0d4&scoped=true&"
import script from "./eduContinue.vue?vue&type=script&lang=js&"
export * from "./eduContinue.vue?vue&type=script&lang=js&"
import style0 from "./eduContinue.vue?vue&type=style&index=0&id=6533a0d4&prod&scoped=true&lang=less&"
import style1 from "./eduContinue.vue?vue&type=style&index=1&id=6533a0d4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6533a0d4",
  null
  
)

export default component.exports